import { merge } from 'lodash'
import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

type State = {
  fontsLoaded: boolean
  heroLoaded: boolean
  siteLoaded: boolean
}

type Actions = {
  // eslint-disable-next-line no-unused-vars
  setLoaderState: (state?: Partial<State>) => void
}

const initialState: State = {
  fontsLoaded: false,
  heroLoaded: false,
  siteLoaded: false
}

const useLoaderStore = create(
  subscribeWithSelector(
    immer<State & Actions>((set) => ({
      ...initialState,
      setLoaderState: (state) => set((prevState) => merge(prevState, state))
    }))
  )
)

export { useLoaderStore }
